const decodeQueryString = (str) => {
  return str ? JSON.parse('{"' + decodeURI(str.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}') : null;
};

export { decodeQueryString };
